import Layout from "../../layouts/layout"
import MainPageLayout from "../../components/main-page-layout/mainPageLayout"
import GalleryCards from "../../components/gallery-card/galleryCard"
import { useRequestProcessor } from "../../api/requestProcessor"
import { useState } from "react"
import { getAllGalleries } from "../../api/galleries"
import Loading from "../../components/loading/loading"
import Pagination from "../../components/pagination/pagination"

const Galleries = () => {
    const [searchKeyword, setSearchKeyword] = useState("")
    const [page, setPage] = useState(1)

    const { Query, Mutate } = useRequestProcessor()

    const { data, isLoading, isError } = Query(
        ['getAllGalleries', searchKeyword, page],
        () => getAllGalleries(searchKeyword, page),
        { enabled: Boolean(searchKeyword) || searchKeyword == "" }
    );

    const handlePageClick = (event) => {
        setPage(event.selected + 1);
    };

    return (
        <Layout>
            <MainPageLayout title={"گالری"} buttonTitle={"گالری جدید"} buttonLink={"/admin/galleries/create"}
                customClass={"!grid !grid-cols-4 !gap-y-8 !gap-x-6 min-h-full wsm:!grid-cols-2"}
            >
                {
                    !isLoading &&
                    <>
                        {
                            data?.data?.length ?
                                data?.data?.map((el) => (
                                    <GalleryCards data={el} />
                                ))
                                :
                                <p className="flex justify-center ">
                                    گالری پیدا نشد
                                </p>
                        }
                    </>
                }
                {
                    isLoading && <Loading />
                }
                {data?.meta?.last_page > 1 && <Pagination handlePageClick={handlePageClick} lastPage={data?.meta?.last_page}  />}
                
            </MainPageLayout>
        </Layout>
    )
}

export default Galleries